import api from '@/services/api'

export default {
  auth(username, password) {
    return api.post('/users/auth', { username, password })
  },

  getUserData() {
    return api.get('/users')
  },

  // Sem parâmetro a API devolve apenas os ativos.
  getUserList(includeInactive = false) {
    return api.get('/users/list', { params: includeInactive ? { includeInactive: true } : {} })
  },

  saveUser(data) {
    if (data._id) {
      return api.put('/users/' + data._id, data)
    } else {
      return api.post('/users', data)
    }
  },

  uploadThumbnailImage(formData) {
    return api.post(`/users/thumbnail`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  removeUser(id) {
    return api.delete('/users/' + id)
  },

  activateUser(id) {
    return api.put('/users/' + id + '/activate')
  },

  inactivateUser(id) {
    return api.put('/users/' + id + '/inactivate')
  },

  getNotifications() {
    return api.get('/users/notifications')
  },
}